/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Cli_TipInputs */

const en_pc_tut_cli_tip = /** @type {(inputs: Pc_Tut_Cli_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run pdfcraft-cli tools to list every available operation.`)
};

const zh_pc_tut_cli_tip = /** @type {(inputs: Pc_Tut_Cli_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运行 pdfcraft-cli tools 可列出所有可用操作。`)
};

/**
* | output |
* | --- |
* | "Run pdfcraft-cli tools to list every available operation." |
*
* @param {Pc_Tut_Cli_TipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_cli_tip = /** @type {((inputs?: Pc_Tut_Cli_TipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Cli_TipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_cli_tip(inputs)
	return zh_pc_tut_cli_tip(inputs)
});
export { pc_tut_cli_tip as "pc.tut.cli.tip" }